// extracted by mini-css-extract-plugin
export default {"ImpersonationBar":"ImpersonationBar_ImpersonationBar"};